import { createRoot, createSignal } from 'solid-js'

/**
 * Estado global de conectividad y autenticación. El interceptor de axios lo
 * actualiza cuando una petición falla por red caída (offline) o por 401
 * (unauthorized). Las páginas lo leen para mostrar la pantalla correspondiente
 * en vez de quedarse en blanco.
 */
const [offline, setOffline] = createRoot(() => createSignal(false))
const [unauthorized, setUnauthorized] = createRoot(() => createSignal(false))

export { offline, setOffline, setUnauthorized, unauthorized }

/** True si el error de axios es de red (sin respuesta del servidor). */
export function isNetworkError(error: unknown): boolean {
  return typeof error === 'object' && error !== null && 'response' in error && error.response === undefined && 'request' in error
}
